import React from "react";
import StudentResourceTemplate from "./StudentResourceTemplate";

export const resourcePage = {
  id: "mechanical-resources",
  department: "Mechanical Engineering",
  short: "ME",
  description: "student_resources for the Department of Mechanical Engineering.",
  resourceSet: "aiml",
  sections: [
    {
      title: "Syllabus",
      items: [
        {
          label: "IA Coverage",
          href: "https://drive.google.com/drive/folders/1d413SOJ-ORk7PkvA1vJxiUtPVAUJI7qg?usp=drive_link",
        },
      ],
    },
    { title: "Timetable", items: [
        // {
        //   label: "1st Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "2nd Semester TimeTable",
        //   href: "#",
        // },
        // {
        //   label: "3rd Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "4th Semester TimeTable",
          href: "/student_resources/ME/TimeTable/4th-Semester-Timetable-2025-2026-UPDATED.pdf",
        },
        // {
        //   label: "5th Semester TimeTable",
        //   href: "#",
        // },
        {
          label: "6th Semester TimeTable",
          href: "/student_resources/ME/TimeTable/6th-Semester-Time-Table-2025-2026-UPDATED.pdf",
        },
    ] },
    { title: "Academic Calendar", items: [
        {
          label: "4th Sem COE",
          href: "/student_resources/ME/COE/ME_4th_sem_coe.jpg",
        },
        {
          label: "6th Sem COE",
          href: "/student_resources/ME/COE/ME_6th_sem_coe.jpg",
        },
      ] 
    },
    // {
    //   title: "Lab Manuals",
    //   items: [
    //     {
    //       label: "1st Year (2025) Combined Lab Manual",
    //       href: "/resources/student-resources/aiml/lab-manuals/2nd-sem-2025-combined.pdf",
    //     },
        
    //   ],
    // },
    {
        title: "Question Papers & Solutions",
        items: [
          {
            label: "Question Paper and Solution",
            href: "https://drive.google.com/drive/folders/1YbnVdzgDvxVGmgkPz85fca3xpohVwYmr?usp=drive_link",
          },
        ],
      },
    {
      title: "Add-On Subjects",
      items: [
        {
          label: "Add-On Course Syllabus",
          href: "https://drive.google.com/drive/folders/1UGWwlOc66a_NsRFxsfKQTtl9ALNTA4j2?usp=drive_linkf",
        },
      ],
    },
    // {
    //   title: "Published Papers & Patents",
    //   items: [
    //     {
    //       label: " INTEGRATED LEGAL CASE ANALYSIS AND DOCUMENT GENERATION SYSTEM USING RETRIEVAL-AUGMENTED AI MODELS ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-396.pdf",
    //     },
    //     {
    //       label: " NETWORK TRAFFIC ANALYSIS FOR SECURITY ANOMALY ",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-799.pdf",
    //     },
    //     {
    //       label: " CROWD SENSE: A REAL-TIME SYSTEM FOR CROWD ANALYTICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-883.pdf",
    //     },
    //     {
    //       label: " AI-DRIVEN MOBILE FORENSICS",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1145.pdf",
    //     },
    //     {
    //       label: " AI-BASED TEXT TO 3D MODEL GENERATOR",
    //       href: "/resources/student-resources/aiml/published-papers-patents/viewjournal-1793-793.pdf",
    //     },
    //   ],
    // },
    {
      title: "Mentor List",
      items: [
        {
          label: "2025-26",
          href: "/student_resources/ME/MentorMentee/mentor_mentee_list_ME.pdf",
        },
      ],
    },
  ],
};

const MechanicalResources = () => <StudentResourceTemplate resourcePage={resourcePage} />;

export default MechanicalResources;
